
















import { Component, Vue } from "vue-property-decorator";
import PurchaseRow from "./PurchaseRow.vue";

@Component({
  components: {
    PurchaseRow
  }
})
export default class PurchaseHeader extends Vue {}
